import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FaChevronDown, FaChevronUp, FaMapMarkerAlt } from 'react-icons/fa';
import { publicAssetUrl } from '../../utils/publicAssetUrl';

const Toggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
  color: #043663;
  font-weight: 700;
  text-align: left;
  &:hover {
    text-decoration: underline;
  }
`;

const DetailBox = styled.div`
  margin-top: 0.5rem;
  padding: 0.65rem 0.75rem;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 0.8rem;
  color: #475569;
  line-height: 1.45;
`;

const Row = styled.div`
  display: flex;
  gap: 0.65rem;
  align-items: flex-start;
`;

const Logo = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #e2e8f0;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  color: #475569;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

/**
 * @param {object} props
 * @param {string} props.teamName
 * @param {string} [props.teamCanton]
 * @param {string} [props.divisionName]
 * @param {number|null} [props.teamSkillLevel]
 * @param {string} [props.teamLogoUrl]
 * @param {boolean} [props.defaultOpen]
 */
export default function TeamDetailExpand({
  teamName,
  teamCanton,
  divisionName,
  teamSkillLevel,
  teamLogoUrl,
  defaultOpen = false,
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(defaultOpen);
  const logo = teamLogoUrl ? publicAssetUrl(teamLogoUrl) : '';
  const initials = (teamName || 'T').trim().slice(0, 2).toUpperCase();

  return (
    <div>
      <Toggle type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        {teamName || t('playerTeamsPage.teamFallback')}
        {open ? <FaChevronUp size={11} aria-hidden /> : <FaChevronDown size={11} aria-hidden />}
      </Toggle>
      {open ? (
        <DetailBox>
          <Row>
            <Logo>
              {logo ? <img src={logo} alt="" loading="lazy" /> : initials}
            </Logo>
            <div>
              <div style={{ fontWeight: 700, color: '#0f172a', marginBottom: '0.25rem' }}>
                {teamName || '—'}
              </div>
              <div>
                <FaMapMarkerAlt size={10} style={{ marginRight: 4, opacity: 0.75 }} aria-hidden />
                {teamCanton || '—'}
                {divisionName ? ` · ${divisionName}` : ''}
              </div>
              {teamSkillLevel != null ? (
                <div style={{ marginTop: '0.2rem', color: '#0f766e', fontWeight: 700 }}>
                  {t('playerTeamsPage.skillPrefix')} {teamSkillLevel}
                </div>
              ) : null}
            </div>
          </Row>
        </DetailBox>
      ) : null}
    </div>
  );
}
